import React, { useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { RadioGroup, FormControlLabel, Radio } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Icon } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
const useClasses = makeStyles()((theme) => ({
  radioGroupList: {
    width: "100%"
  },
  radioGroupListItem: {
    display: "flex",
    justifyContent: "space-between",
    height: theme.spacing(6),
    marginLeft: "0",
    marginRight: "0",
    padding: theme.spacing(0, 1.5)
  },
  radioGroupListItemSelected: {
    backgroundColor: theme.palette.primary.light
  },
  radioGroupListCheck: {
    fontSize: theme.typography.h6.fontSize
  }
}));
function RadioGroupList({ value, options, scrollToSelected = false, onChange }) {
  const ref = useRef(null);
  const { formatMessage } = useIntl();
  const { classes } = useClasses();
  useEffect(() => {
    if (ref.current && scrollToSelected) ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [scrollToSelected]);
  return /* @__PURE__ */ React.createElement(RadioGroup, { value, onChange, className: classes.radioGroupList }, options.map((option, index) => /* @__PURE__ */ React.createElement(
    FormControlLabel,
    {
      labelPlacement: "start",
      className: [classes.radioGroupListItem, option.value === value ? classes.radioGroupListItemSelected : null].join(" "),
      key: index,
      ref: option.value === value ? ref : null,
      value: option.value,
      control: /* @__PURE__ */ React.createElement(
        Radio,
        {
          key: index,
          icon: /* @__PURE__ */ React.createElement(React.Fragment, null),
          checkedIcon: /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.Confirm, className: classes.radioGroupListCheck }),
          color: "secondary"
        }
      ),
      label: typeof option.label === "string" ? option.label : formatMessage(option.label)
    }
  )));
}
export {
  RadioGroupList
};
//# sourceMappingURL=RadioGroupList.js.map
